import get from 'lodash.get';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { CartFeatures } from '~shared/modules/shopping-cart-store/models';
import { GATrackingEventType, GaTrackingEventName } from '../../constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingPurchaseEvent } from './ga-tracking-purchase-event.model';
import { GaTrackingCheckoutService } from '~shared/modules/ga-tracking/utils/ga-tracking-checkout.service';
import { IOfferLine, ITotal } from '~shared/modules/cart/models';
import { OrderPayment } from '~app/modules/checkout/models';
import { TrackingCategoryItem } from '~shared/modules/shopping-cart-global/models';
import { getCategoryIdHelper } from '~app/modules/generic/helpers/get-category-id.helper';
import { getCategoryNameHelper } from '~app/modules/generic/helpers/get-category-name.helper';

export class GATrackingPurchaseGA4Event extends GATrackingPurchaseEvent {
  constructor(
    protected offerLines: CartOfferLine[],
    protected totals: ITotal,
    protected orderPayment: OrderPayment,
    protected priceType: string,
    protected paymentMethod: string,
    protected currency: string,
    protected cartFeatures: CartFeatures,
    protected userClassificationType: string
  ) {
    super(offerLines, totals, orderPayment, priceType);
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PurchaseGA4;
  }

  getPayload(): GATrackingEventPayload {
    const items = this.offerLines.map((offer: IOfferLine) => ({
      item_name: offer.item?.name,
      item_id: offer.item?.id,
      price: +offer.price?.offer,
      item_brand: offer.seller?.name,
      item_promo: offer.item?.hasPromotion ? 'yes' : 'no',
      quantity: offer.quantity,
      item_discount_rate: offer.trackingData?.dimension31 ?? '0',
      item_service_addition: offer.trackingData?.dimension58 ?? 'no',
      item_black_deal_label: offer.trackingData?.dimension51 ?? 'no',
      item_limited_stock: offer.trackingData?.dimension52 ?? 'no',
      item_offer_id: offer.trackingData?.dimension54 ?? 'no',
      item_placeholder_attribute: offer.trackingData?.dimension43 ?? 'no',
      item_on_sale: offer.trackingData?.onSale ?? false,
      item_custom: GaTrackingCheckoutService.generateItemCustom(this.cartFeatures, offer),
      category_tree: offer.trackingData?.categoryTree?.map((category: string | TrackingCategoryItem) => ({
        id: getCategoryIdHelper(category),
        name: getCategoryNameHelper(category),
      })),
      servicePrice: +offer.trackingData?.servicePrice ?? 0,
      item_list_name: offer.trackingData?.itemListName ?? ''
    }));
    const gtmCustom = {
      ...GaTrackingCheckoutService.getAuthorizeFlow,
      price_type: this.priceType,
      'content-name': window.location.pathname + window.location.search,
      GA360_customerType: this.userClassificationType,
      ecommerce: {
        transaction_id: get(this.orderPayment, 'payload.payment.orderId', ''),
        value: +this.totals?.total ?? 0,
        tax: +this.totals?.subTotalTax ?? 0,
        shipping: +this.totals?.shippingCostTotal,
        coupon: '',
        currency: this.currency,
        payment_method: this.paymentMethod,
        items: items.map((item) => GaTrackingCheckoutService.mapCategoriesInfo(item)),
      },
    };

    return {
      event: GaTrackingEventName.PurchaseGA4,
      gtmCustom,
    };
  }
}
